<script>
    import Helpers from '@/tools/Helpers';
    export default {
        name: 'popupMix',
        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },
            closePopup(){
                this.$store.commit('SET_POPUP', '');
                this.gaEvents('places','click','close');
            },
            afterEnter() {
                this.$refs['popup'].classList.add('show');
            }
        },
        watch: {
            '$route'() {
                this.$store.commit('SET_POPUP', '');
                this.gaEvents('places','click','close');
                next();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// popup_mix.vue?9bec5b88